import { Box, Typography } from "@mui/material";
import FormActionButton from "../../buttons/formActionButton.component";
import { DeleteForever } from "@mui/icons-material";
import { useState } from "react";
import CustomDialog from "../../muiDialogs/dialog.component";
import { dialogMessages } from "../utils";

const DeleteFieldForm = ({ handleDeleteField }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      gap={2}
    >
      <Typography fontSize="12px" color="#616161">
        Ex cupidatat fugiat ad enim sint non. Aute anim ad magna ea elit et
        sunt. Ut velit mollit aliqua ut. Velit culpa velit culpa cupidatat
        labore. Excepteur dolore dolor et aliquip. Incididunt ex nisi proident
        nulla ad exercitation voluptate sint ad labore cillum nisi eu magna.
      </Typography>
      <Box width="100%">
        <FormActionButton
          startIcon={<DeleteForever />}
          label="Elimina terreno"
          onClick={handleDialogOpen}
        />
      </Box>
      {dialogOpen && (
        <CustomDialog
          open={dialogOpen}
          onClose={handleDialogClose}
          onConfirm={handleDeleteField}
          title={dialogMessages.deleteCustomerField.title}
          description={dialogMessages.deleteCustomerField.description}
        />
      )}
    </Box>
  );
};

export default DeleteFieldForm;
